import React, { FC, memo, useRef } from 'react'
import styled, { StyledProps } from 'styled-components'
import FacetItemWrapper from './FacetItemWrapper'
import { Button } from '../../Button/desktop'
import { Form } from '../../Form/desktop'
import { useFacetFormCore } from '../bll'
import { IFacetFormProps } from '../types'
import SC from '../base/FacetForm.styles'

const { ScrollItemsWrapper, ScrollItemsWrapperInner } = SC

const StyledScrollItemsWrapperInner = styled<StyledProps<any>>(ScrollItemsWrapperInner)`
  max-height: ${(props) => props.maxHeight};
`

/** Форма фасета */
const FacetForm: FC<IFacetFormProps> = (props) => {
  const {
    items,
    maxItems,
    expandButtonText,
    controlName,
    isRadio,
    isForcedArray,
    fontWeight,
    fillByQuery,
    isSorted = true,
    isSelect,
  } = props

  const scrollWrapperRef = useRef(null)

  const { visibleItems, onExpand, isExpanded, scrollWrapperMaxHeight } = useFacetFormCore(
    {
      items,
      maxItems,
      scrollWrapperRef,
      controlName,
      isSorted,
      isSelect,
    }
  )

  return (
    <Form fillByQuery={fillByQuery}>
      <ScrollItemsWrapper active={isExpanded}>
        <StyledScrollItemsWrapperInner
          maxHeight={scrollWrapperMaxHeight}
          active={isExpanded}
          ref={scrollWrapperRef}
        >
          {visibleItems.map((facetItem) => (
            <FacetItemWrapper
              facet={facetItem}
              controlName={controlName}
              isRadio={isRadio}
              isForcedArray={isForcedArray}
              key={facetItem.value}
              fontWeight={fontWeight}
            />
          ))}

          {maxItems && items.length > maxItems && !isExpanded && (
            <Button view='link' size='xsmall' onClick={onExpand}>
              {expandButtonText}
            </Button>
          )}
        </StyledScrollItemsWrapperInner>
      </ScrollItemsWrapper>
    </Form>
  )
}

export default memo(FacetForm)
